import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import ChargerModule from 'components/chargerModule/ChargerModule';
import { getAllBillingEntitiesBord } from 'services/billing/storageBillingInvoices.service';
import { getCountryWarehouseData } from 'services/countriesList';
import { getListOfCountriesByOfferedService } from '../../utils/getCountries';
import { ISellerBillingEntity } from 'types/billing.types';
import { ICountryDetail } from 'types/bussines';
import useResetData from 'hooks/useResetData';
import BillingListingTableContent from './components/BillingListingTableContent/BillingListingTableContent';
import BillingListingTableHeader from './components/BillingListingTableHeader/BillingListingTableHeader';
import BillingModuleListingFilters from './components/BilllingModuleListingFilters/BillingModuleListingFilters';
import './BillingModuleListing.scss';

const BillingModuleListing = () => {
  const [searchText, setSearchText] = useState('');
  const [listOfCountries, setListOfCountries] = useState<ICountryDetail[]>([]);
  const [listOfCountriesWarehouse, setListOfCountriesWarehouse] = useState<ICountryDetail[]>([]);
  const [listOfBillingEntityBord, setListOfBillingEntityBord] = useState<ISellerBillingEntity[]>([]);
  const [availableMonths, setAvailableMonths] = useState<string[]>([]);
  const [monthValueMap, setMonthValueMap] = useState<Map<string, string>>(new Map());
  const { resetStorageDataWithLoaders } = useResetData();
  const hasInitialized = useRef(false);

  const infoSideBar = useMemo(() => ({ position: 'billing' }), []);
  const headerInfo = useMemo(
    () => ({
      title: 'Facturación',
      subtitle: '- Almacenamiento'
    }),
    []
  );

  const loadInitialData = useCallback(async () => {
    getListOfCountriesByOfferedService(countries => {
      setListOfCountries(countries as ICountryDetail[]);
    });
    const countriesWarehouse = await getCountryWarehouseData();
    setListOfCountriesWarehouse(countriesWarehouse as ICountryDetail[]);
    const billingEntities = await getAllBillingEntitiesBord();
    setListOfBillingEntityBord(billingEntities);
  }, []);

  const handleAvailableMonthsChange = useCallback((months: string[], valueMap: Map<string, string>) => {
    setAvailableMonths(months);
    setMonthValueMap(valueMap);
  }, []);

  useEffect(() => {
    loadInitialData();
  }, [loadInitialData]);

  useEffect(() => {
    if (!hasInitialized.current) {
      resetStorageDataWithLoaders();
      hasInitialized.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="billingModuleListing">
      <ChargerModule
        headerInfo={headerInfo}
        infoSideBar={infoSideBar}
        viewSearchBar
        searchbarPlaceholder="Buscar por empresa, razón social o ID de empresa…"
        searchText={searchText}
        setSearchText={setSearchText}
        custonMarginRightButtonsContainer="380px"
      >
        <BillingModuleListingFilters
          listOfCountries={listOfCountriesWarehouse}
          listOfBillingEntityBord={listOfBillingEntityBord}
          availableMonths={availableMonths}
          monthValueMap={monthValueMap}
        />
        <BillingListingTableHeader />
        <BillingListingTableContent
          searchText={searchText}
          listOfCountries={listOfCountries}
          onAvailableMonthsChange={handleAvailableMonthsChange}
        />
      </ChargerModule>
    </div>
  );
};

export default BillingModuleListing;
